import Component from '@glimmer/component'
import { action } from '@ember/object'
import { service } from '@ember/service'
import t from 'ember-intl/helpers/t'
import Banner from 'customer-flows/components/ui-kit/banner'

export default class DemoBanner extends Component {
  @service declare application: Application

  @action
  onExitClick() {
    this.application.exit()
  }

  <template>
    {{#if this.application.isDemoMode}}
      <Banner
        data-testid='demo-mode-banner'
        @title={{t 'demo.banner.title'}}
        @message={{t 'demo.banner.subtitle'}}
        @actionLabel={{t 'demo.banner.exit'}}
        @onAction={{this.onExitClick}}
      />
    {{/if}}
  </template>
}
